<template>
    <div class="form-group">
        <label v-if="label" :for="formName"><strong v-if="titleBold">{{ titleBold }}</strong>{{ title }}</label>
        <slot></slot>
    </div>
</template>
<script>
export default {
    name: 'OFormGroup',
    props: {
        name: String,
        title: String,
        titleBold: String,
        label: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            formName: null
        }
    },
    mounted() {
        this.formName = this.name;
    }
}
</script>